import ErrorNotFound from 'templates/ErrorNotFound';

const Custom404 = function ({ isMobile, isWebView }) {
  return <ErrorNotFound isMobile={isMobile} isWebView={isWebView} />;
};

export default Custom404;
